import store from "./../store";
import router from "./../router";
import DashboardAPI from "./../api/dashboard";
import CompraAPI from "./../api/compra";

export const nomeMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

export const formatarParametrosObjParaUrl = (filtros = {}) => {
  const callback_transformacao = key => Array.isArray(filtros[key])
    ? filtros[key].map(value => `&${key}[]=${value}`).join('')
    : `&${key}=${filtros[key]}`;

  return Object.keys(filtros)
    .map(callback_transformacao)
    .join('')
    .replace('&', '?');
}

export const colocarEmTelaCheia = () => {
  if (localStorage.permitir_tela_cheia !== 'S') return;

  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  }
}

export const primeiraLetraMaiuscula = (str) => {
  const primeira_letra = `${str[0] || ''}`.toUpperCase();
  return `${primeira_letra.concat(str.substring(1).toLowerCase())}`
}

export const arrayColumn = (array, column) => {
  let newArray = [];

  array.forEach(item => {
    if (typeof column === 'string') {
      newArray.push(item[column])
    } else {
      let newObj = {}

      column.forEach(col => {
        newObj[col] = item[col]
      })

      newArray.push(newObj)
    }
  })

  return newArray
}

export const formatarValorMonetario = (valor = 0, moeda = 'R') => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: moeda === "R" ? "BRL" : "USD",
    currencyDisplay: moeda === "R" ? "symbol" : "narrowSymbol",
  }).format(valor);
};

export const formatarValor = (valor = 0) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    maxDigits: 4
  }).format(valor);
};

export const truncarEFormatarValor = (valor, qtde_decimais = 0) => {
  const fator = parseFloat(Math.pow(10, qtde_decimais))
  return formatarValorComCasas(Math.floor(valor * fator) / fator, qtde_decimais);
}

export const formatarValorComCasas = (valor = 0, casasDecimais) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    maxDigits: 4,
    maximumFractionDigits: casasDecimais,
    minimumFractionDigits: casasDecimais
  }).format(valor);
};

export const formatarMoeda = (moeda) => {
  if (!moeda) {
    return 'R$';
  }

  switch (moeda) {
    case 'R': return 'R$';
    case 'D': return '$';
    case 'UE': return '€';

    default: return 'ST';
  }
}

export const formatarValorPercent = (valor = 0) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    maxDigits: 2
  }).format(valor);
};

export const exibirMensagem = (mensagem, color, timeout) => {
  const snackbar = { mensagem, color, timeout, ativo: true };
  store.dispatch("snackbar/habilitarSnackBar", snackbar);
};

export const buscarCompraFornecedor = (fornecedorSelecionado, tipo = 1) => {
  fornecedorSelecionado.tipo = tipo;

  if (fornecedorSelecionado) {
    if (tipo === 1) {
      let data = {
        id: 0,
        nome_completo: "sem comprador"
      };

      store.dispatch("fornecedor/setComprador", data);
    }

    store.dispatch("fornecedor/setFornecedor", fornecedorSelecionado);
    store.dispatch('filtrosProdutos/set_exibir_produtos', true);
    colocarEmTelaCheia();
    router.push({ name: "Compra" });
  } else {
    const mensagem = "Informe um fornecedor!";
    const color = "error";
    const timeout = 3000;
    exibirMensagem(mensagem, color, timeout);
  }
};

export const buscarCompraFornecedorSegmento = (
  fornecedorSelecionado,
  tipo = 1
) => {
  let data = {
    id: fornecedorSelecionado.idfornecedor,
    razao_social: fornecedorSelecionado.razao_social,
    idSegmento: fornecedorSelecionado.idfamilia_produto,
    descricao_segmento: fornecedorSelecionado.descricao_segmento,
    tipo: tipo
  };

  if (fornecedorSelecionado) {
    if (tipo === 1) {
      let data = {
        id: 0,
        nome_completo: "sem comprador"
      };

      store.dispatch("fornecedor/setComprador", data);
    }

    store.dispatch("fornecedor/setFornecedor", data);
    colocarEmTelaCheia();
    router.push({ name: "Compra" });
  } else {
    const mensagem = "Informe um fornecedor!";
    const color = "error";
    const timeout = 3000;
    exibirMensagem(mensagem, color, timeout);
  }
};

export const verificarToken = () => {
  if (!localStorage.getItem("token")) router.push({ name: "Home" });

  const headers = iniciarRequisicao();

  DashboardAPI.getValidateUser(headers)
    .then(response => {
      const token = response.data.token;
      localStorage.setItem("token", token);

      let hash = localStorage.getItem("hash_acesso");
      let user = response.data.user;

      if (hash != user.hash_acesso) {
        alert(
          "A licença do usuário já esta sendo utilizada em outro dispositivo. Para obter mais licenças entrar em contato com setor comercial (92) 98478-2731"
        );
        router.push({ name: "Home" });
      }
    })
    .catch(() => {
      logout();
    });
};

export const logout = () => {
  const itens = [
    "token",
    "nome",
    "email",
    "service",
    "setor",
    "hash_acesso",
    "urls",
    "empresa",
    "id",
    "filial_compra",
    "fator_atuacao"
  ];

  itens.forEach(item => {
    localStorage.removeItem(item);
  });

  store.commit("app/setUsuario", {}, { route: true });
  store.commit("app/setDrawerMenu", false, { route: true });
  store.commit("notificacao/setItens", [], { route: true });
  store.commit("notificacao/setItem", [], { route: true });
  store.commit("notificacao/setNews", [], { route: true });
  store.commit("wkfAutorizacao/setItens", [], { route: true });
  store.commit(
    "wkfAutorizacao/setTipo",
    {
      tipo: {
        id: "APR",
        label: "APROVAR",
        title: ""
      }
    },
    { route: true }
  );
  store.commit("wkfControleGrupo/setItens", [], { route: true });
  store.commit("wkfItem/setItens", [], { route: true });
  store.commit("wkfItem/setTabela", [], { route: true });
  store.commit("wkfItem/setColuna", [], { route: true });

  store.dispatch('loading/resetarQtdeRequisicoes');

  router.push({ name: "Home" });
};

export const getHeaderRequisicao = () => {
  const token = localStorage.getItem("token");

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`
  };

  store.dispatch("loading/habilitarLoading", false);

  return headers;
};

export const iniciarRequisicao = () => {
  const token = localStorage.getItem("token");

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`
  };

  store.dispatch("loading/habilitarLoading", true);

  return headers;
};

export const getCategorias = page => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getCategoriasTabela(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        store.dispatch("tabela/setItems", response.data.categorias);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getCategoriasGrupo = (page, grupo) => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page,
    grupo: grupo
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getCategoriasTabelaGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.categorias.data.forEach(segmentos => {
          segmentos.icon_analise_segmentos = "mdi-eye";
        });

        store.dispatch("tabela/setItems", response.data.categorias);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getCompradores = page => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getCompradoresTabela(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.compradores.data.forEach(compradores => {
          compradores.icon_analise = "mdi-eye";
          compradores.eficiencia = formatarValorPercent(compradores.eficiencia);
        });

        store.dispatch("tabela/setItems", response.data.compradores);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getCompradoresGrupo = (page, grupo) => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page,
    grupo: grupo
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getCompradoresTabelaGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.compradores.data.forEach(compradores => {
          compradores.icon_analise = "mdi-eye";
          compradores.eficiencia = formatarValorPercent(compradores.eficiencia);
        });

        store.dispatch("tabela/setItems", response.data.compradores);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getFornecedores = page => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getFornecedoresTabela(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.fornecedores.data.forEach(fornecedor => {
          fornecedor.icon_compra = "mdi-cart";
        });

        store.dispatch("tabela/setItems", response.data.fornecedores);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getFornecedoresGrupo = (page, grupo) => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page,
    grupo: grupo
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getFornecedoresTabelaGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.fornecedores.data.forEach(fornecedor => {
          fornecedor.icon_compra = "mdi-cart";
        });

        store.dispatch("tabela/setItems", response.data.fornecedores);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getProdutos = page => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getProdutosTabela(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        const produtos = response.data.produtos;

        setarStatus(produtos);

        store.dispatch("tabela/setItems", produtos);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

// export const getProdutosGrupo = (page, grupo) => {
//   store.dispatch("tabela/setItems", []);
//
//   const headers = iniciarRequisicao();
//
//   const params = {
//     page: page,
//     grupo: grupo
//   };
//
//   store.dispatch(
//     "loading/addRequisicao",
//     DashboardAPI.getProdutosTabelaGrupo(headers, params)
//       .then(response => {
//         const token = response.data.token;
//         localStorage.setItem("token", token);
//
//         const produtos = response.data.produtos;
//
//         setarStatus(produtos);
//
//         store.dispatch("tabela/setItems", produtos);
//       })
//       .catch(() => {
//         store.dispatch("loading/habilitarLoading", false);
//         logout();
//       })
//   );
// };

export const setarStatus = produtos => {
  produtos.data.forEach(item => {
    const objetoStatus = buscarObjetoStatus(item.status);
    item.descricaoStatus = objetoStatus[0];
  });
};

export const statusProdutos = [
  {
    status: "E",
    descricao: "Nível elevado",
    cor: "#FD0001",
    descritivo: "A falta deste item afetará significativamente os resultados"
  },
  {
    status: "A",
    descricao: "Nível alto",
    cor: "#FFBF05",
    descritivo: "A falta deste item afetará parte dos resultados"
  },
  {
    status: "M",
    descricao: "Nível médio",
    cor: "#FFFE02",
    descritivo: "A falta deste item poderá afetar os resultados"
  },
  {
    status: "B",
    descricao: "Nível baixo",
    cor: "#00AE51",
    descritivo:
      "A falta deste item não afetará de forma relevante os resultados"
  },
  {
    status: "O",
    descricao: "Nível ordinário",
    cor: "#0071C1",
    descritivo:
      "A falta deste item não afetará de forma relevante os resultados"
  },
  {
    status: "S",
    descricao: "Sob encomenda",
    cor: "#0D0D0D",
    descritivo:
      "Item com perfil estratégico, sua compra deverá ser avaliada apenas quando demandadas pelas Unidades demandadoras, não entrando em cálculo de ressuprimento"
  }
];

export const buscarObjetoStatus = status => {
  const nivel_servico = statusProdutos.filter(item => item.status == status);

  const nivel_servico_default = {
    status: "S",
    descricao: "Sob encomenda",
    cor: "#0D0D0D",
    descritivo:
      "Item com perfil estratégico, sua compra deverá ser avaliada apenas quando demandadas pelas Unidades demandadoras, não entrando em cálculo de ressuprimento"
  };

  return (nivel_servico.length > 0) ? nivel_servico : [nivel_servico_default];
};

export const getPedidos = page => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getPedidosTabela(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.pedidos.data.forEach(pedido => {
          pedido.icon_eye = "mdi-eye";
        });

        store.dispatch("tabela/setItems", response.data.pedidos);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};
export const getProdutosCompraGrupo = (
  page,
  grupo,
  filial = 0,
  idcomprador = 0,
  segmento = 0
) => {
  if (store.getters['loading/getLoadingTable']) return;

  //store.dispatch("tabela_compra/setItems", []);
  store.dispatch("loading/habilitarLoadingTable", true);

  const headers = iniciarRequisicao();
  let usuario_id = localStorage.getItem("id");

  const params = {
    fornecedor: page,
    grupo: grupo,
    filial_compra: grupo > 0 ? filial : 0,
    comprador: idcomprador,
    id_segmento: segmento,
    usuario: parseInt(usuario_id),
    analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
    compra_por_filial: store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'] ? 'S' : 'N',
    considerar_estoque_grupo: store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'] ? 'S' : 'N',
  };

  store.dispatch(
    "loading/addRequisicao",
    CompraAPI.getProdutosCompraGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        const produtos = response.data.produtos;

        produtos.forEach((produto, i) => {
          produto.index = i;
          produto.icone_tipo =
            Number(produto.estoque_transito) > 0
              ? "mdi-truck"
              : produto.tipo == "FC"
                ? "mdi-clock"
                : "";

          produto.descricao_icone =
            Number(produto.estoque_transito) > 0
              ? "Produto em Trânsito"
              : produto.tipo == "FC"
                ? "Produto em Forecast"
                : "";

          const objetoStatus = buscarObjetoStatus(produto.status);
          produto.cor = objetoStatus[0].cor;
          produto.status_descricao = objetoStatus[0].descricao;
          produto.descritivo = objetoStatus[0].descritivo;

          produto.sugestao_fixa = produto.sugestao
          produto.sugestao_fixa_convertivel = produto.sugestao
          produto.loteMinimoAuxiliar = produto.lote_minimo
        });

        store.dispatch("loading/habilitarLoading", true);
        store.dispatch("loading/habilitarLoadingTable", false);
        store.dispatch("tabela_compra/setItems", produtos);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getPedidosGrupo = (page, grupo) => {
  store.dispatch("tabela/setItems", []);

  const headers = iniciarRequisicao();

  const params = {
    page: page,
    grupo: grupo
  };

  store.dispatch(
    "loading/addRequisicao",
    DashboardAPI.getPedidosTabelaGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        response.data.pedidos.data.forEach((pedido, index) => {
          pedido.index = index;
          pedido.icon_eye = "mdi-eye";
        });

        store.dispatch("tabela/setItems", response.data.pedidos);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const  getProdutosSobEncomendaGrupo = (
  page,
  grupo,
  filial = 0,
  idcomprador = 0,
  segmento = 0
) => {
  if (store.getters['loading/getLoadingTable']) return;

  //store.dispatch("tabela_compra/setItems", []);
  store.dispatch("loading/habilitarLoadingTable", true);

  const headers = iniciarRequisicao();

  let usuario_id = localStorage.getItem("id");

  const params = {
    fornecedor: page,
    grupo: grupo,
    filial_compra: filial,
    comprador: idcomprador,
    id_segmento: segmento,
    usuario: parseInt(usuario_id),
    analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
    compra_por_filial: store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'] ? 'S' : 'N',
    considerar_estoque_grupo: store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'] ? 'S' : 'N',
  };

  store.dispatch(
    "loading/addRequisicao",
    CompraAPI.getProdutosSobEncomendaGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        const produtos = response.data.produtos;

        produtos.forEach((produto, i) => {
          produto.index = i;

          if (produto.tipo === "TR") {
            produto.icone_tipo = "mdi-truck";
            produto.descricao_icone = "Produto em Trânsito";
          } else if (produto.tipo === "FC") {
            produto.icone_tipo = "mdi-clock";
            produto.descricao_icone = "Produto em Forecast";
          } else if (produto.tipo === "TQ") {
            produto.icone_tipo = "mdi-gauge";
            produto.descricao_icone = "Item para completar compra";
          } else if (produto.tipo === "EE") {
            produto.icone_tipo = "mdi-cube-scan";
            produto.descricao_icone = "Item para completar estoque estético";
          } else {
            produto.icone_tipo = "";
            produto.descricao_icone = "";
          }

          const objetoStatus = buscarObjetoStatus(produto.status);
          produto.cor = objetoStatus[0].cor;
          produto.status_descricao = objetoStatus[0].descricao;
          produto.descritivo = objetoStatus[0].descritivo;

          produto.sugestao_fixa = produto.sugestao;
          produto.sugestao_fixa_convertivel = produto.sugestao;
          produto.loteMinimoAuxiliar = produto.lote_minimo;
        });

        store.dispatch("loading/habilitarLoading", true);
        store.dispatch("loading/habilitarLoadingTable", false);

        store.dispatch("tabela_compra/setItems", produtos);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getProdutosCompraGeralGrupo = (
  page,
  grupo,
  filial = 0,
  idcomprador = 0,
  segmento = 0
) => {
  if (store.getters['loading/getLoadingTable']) return;

  //store.dispatch("tabela_compra/setItems", []);
  store.dispatch("loading/habilitarLoadingTable", true);

  const headers = iniciarRequisicao();

  let usuario_id = localStorage.getItem("id");

  const params = {
    fornecedor: page,
    grupo: grupo,
    filial_compra: filial,
    comprador: idcomprador,
    id_segmento: segmento,
    usuario: parseInt(usuario_id),
    analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
    compra_por_filial: store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'] ? 'S' : 'N',
    considerar_estoque_grupo: store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'] ? 'S' : 'N',
    exibir_produtos_inativos: store.getters['CompraProdutosGerais/getExibirProdutosInativos'] ? 'S' : 'N',
    histogramas: store.getters['CompraProdutosGerais/getHistogramas'],
    status: store.getters['CompraProdutosGerais/getStatus'],
    aplicacao: store.getters['CompraProdutosGerais/getAplicacao']
  };

  store.dispatch(
    "loading/addRequisicao",
    CompraAPI.getProdutosCompraGeralGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        const produtos = response.data.produtos;

        produtos.forEach((produto, i) => {
          produto.index = i;
          produto.icone_tipo =
            Number(produto.estoque_transito) > 0
              ? "mdi-truck"
              : produto.tipo == "FC"
                ? "mdi-clock"
                : "";

          produto.descricao_icone =
            Number(produto.estoque_transito) > 0
              ? "Produto em Trânsito"
              : produto.tipo == "FC"
                ? "Produto em Forecast"
                : "";

          const objetoStatus = buscarObjetoStatus(produto.status);
          produto.cor = objetoStatus[0].cor;
          produto.status_descricao = objetoStatus[0].descricao;
          produto.descritivo = objetoStatus[0].descritivo;

          produto.sugestao_fixa = produto.sugestao;
          produto.sugestao_fixa_convertivel = produto.sugestao;
          produto.loteMinimoAuxiliar = produto.lote_minimo

          // produto.carrinho = 0
        });

        store.dispatch("tabela_compra/setItems", produtos);
        store.dispatch("loading/habilitarLoadingTable", false);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const getProdutosTransitoGrupo = (
  page,
  grupo,
  filial = 0,
  comprador = 0,
  segmento = 0
) => {
  if (store.getters['loading/getLoadingTable']) return;

  //store.dispatch("tabela_compra/setItems", []);
  store.dispatch("loading/habilitarLoadingTable", true);

  const headers = iniciarRequisicao();

  const params = {
    fornecedor: page,
    grupo: grupo,
    filial_compra: filial,
    comprador,
    id_segmento: segmento,
    analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
  };

  store.dispatch(
    "loading/addRequisicao",
    CompraAPI.getProdutosTransitoGrupo(headers, params)
      .then(response => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        const produtos = response.data.produtos;

        produtos.forEach((produto, i) => {
          produto.index = i;
          produto.icone_tipo = "";
          const objetoStatus = buscarObjetoStatus(produto.status);
          produto.cor = objetoStatus[0].cor;
          produto.status_descricao = objetoStatus[0].descricao;
          produto.descritivo = objetoStatus[0].descritivo;

          produto.compra_transito = formatarValor(produto.compra_transito);
          produto.carrinho = 0;

          produto.sugestao_fixa = produto.sugestao;
          produto.sugestao_fixa_convertivel = produto.sugestao;
          produto.loteMinimoAuxiliar = produto.lote_minimo
        });

        store.dispatch("tabela_compra/setItems", produtos);
        store.dispatch("loading/habilitarLoadingTable", false);

        //store.dispatch("loading/habilitarLoading",false);
      })
      .catch(() => {
        store.dispatch("loading/habilitarLoading", false);
        logout();
      })
  );
};

export const atualizarTotaisGrupo = (
  id = 0,
  grupo,
  filial = 0,
  idcomprador = 0,
  id_segmento = 0
) => {
  const headers = iniciarRequisicao();

  let usuario_id = localStorage.getItem("id");

  const params = {
    fornecedor: id,
    grupo: grupo,
    filial_compra: filial,
    comprador: idcomprador,
    id_segmento: id_segmento,
    usuario: parseInt(usuario_id),
    analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
    compra_por_filial: store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'] ? 'S' : 'N',
    considerar_estoque_grupo: store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'] ? 'S' : 'N',
  };

  store.dispatch("fornecedor/setItensCompra", null);
  store.dispatch("fornecedor/setItensForn", null);
  store.dispatch("fornecedor/setItensTransito", null);
  store.dispatch("fornecedor/setItensSobEncomenda", null);

  CompraAPI.getTotaisGrupo(headers, params)
    .then(response => {
      const token = response.data.token;
      localStorage.setItem("token", token);

      store.dispatch(
        "fornecedor/setItensCompra",
        response.data.totais.lista_compras
      );
      store.dispatch(
        "fornecedor/setItensForn",
        response.data.totais.lista_geral
      );
      store.dispatch(
        "fornecedor/setItensTransito",
        response.data.totais.lista_transito
      );
      store.dispatch(
        "fornecedor/setItensSobEncomenda",
        response.data.totais.lista_sob_encomenda
      );
    })
    .catch(() => {
      this.$store.dispatch("loading/habilitarLoading", false);
      this.Helpers.logout();
    });
};

export const formatarDataBrComNomeDoMes = (data) => {
  const [dia, mes, ano] = data.split("/");
  const nome_mes = (nomeMeses[parseInt(mes) - 1] || mes).substring(0, 3);
  return `${dia} ${nome_mes} ${ano.substring(2, 4)}`;
}

export function adicionarInputsFiltros(form, filtros, key) {
  if (Array.isArray(filtros[key])) {
    filtros[key].forEach(item => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', `${key}[]`);
      input.setAttribute('value', item);
      form.appendChild(input);
    });
    delete filtros[key];
  }
}

export function executarCallbackAposFinalizacaoRequisicoesBackend(callback) {

  const callback_interval = () => {
    const qtd_requisicoes_backend = store.getters['loading/qtde_requisicoes'];

    if (Number(qtd_requisicoes_backend || 0) > 0) {
      return;
    }

    clearInterval(intervalo);
    callback();
  };

  const intervalo = setInterval(callback_interval, 100);
}
